import Swal from 'sweetalert2';
import { url } from '../api/api';
import { loadJWT } from './loadJWT';

export const loadClients = async () => {
  let clients = [];
  const { token } = loadJWT();
  await url
    .get('/clientes?filter={"where": {"FechaBaja": {"eq": null}}}', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then(response => {
      clients = response.data.map(resp => resp);
    })
    .catch(e => {
      Swal.fire('Error', e?.response?.data?.error?.message || 'Error. Contacte con el administrador', 'error');
      return;
    });

  return clients;
};
